import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { OnCarouselIndexChangeAttemptProps } from 'components/sections/carousel/useCarousel';
import { triadSuperFetch } from 'utils/superFetch';
import { gaEvent } from 'utils/trackingFunctions';
import { GA_EVENTS_MAP } from './EVENT_TYPES';

export function handleCarouselInteractionTracking(
  rowIndex: number,
  schoolCode: string,
  args: OnCarouselIndexChangeAttemptProps,
  schoolImpressionGroupGuid: string
): void {
  const { didChange, direction, isFirstAttempt } = args;

  if (didChange) {
    gaEvent({
      event: GA_EVENTS_MAP.CAROUSEL_INTERACTION,
      action: direction,
      category: isFirstAttempt ? 'First Interaction' : 'Repeated Interaction',
      label: `row ${rowIndex + 1}`,
    });

    triadSuperFetch(`${TRIAD_PROXY_ROUTE}/logevent`, {
      method: 'POST',
      timeout: 3000,
      body: {
        schoolCode,
        schoolImpressionGroupGuid,
        eventName: `SchoolImpressionGroup.CarouselInteraction.${
          direction === 'next' ? 'Next' : 'Previous'
        }.${isFirstAttempt ? 'First Interaction' : 'Repeated Interaction'}`,
        eventData: [
          {
            name: 'action',
            value: direction,
          },
          {
            name: 'category',
            value: isFirstAttempt
              ? 'First Interaction'
              : 'Repeated Interaction',
          },
          {
            name: 'rowIndex',
            value: rowIndex,
          },
        ],
      },
    });
  }
}
